var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "mt-4 mb-2" }, [_vm._v("Attachments")]),
    _vm._v(" "),
    _vm.$_can("claims.files.store")
      ? _c(
          "div",
          { staticClass: "row mb-5 mt-2" },
          [
            _c(
              "div",
              { staticClass: "col-12 col-sm-12 col-md-2" },
              [
                _c("ClaimFileUpload", {
                  ref: "refGalleryUpload",
                  attrs: {
                    label: "<u>Browse</u> or drag to upload",
                    "type-id": 5,
                    "style-class": "rectangle-upload",
                    model: "claims",
                    "model-id": _vm.claim.id
                  },
                  on: { update: _vm.loadClaim }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.claimFiles
              ? _vm._l(_vm.claimFiles, function(file) {
                  return _c(
                    "div",
                    { key: file.id, staticClass: "col-12 col-sm-12 col-md-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "rec-upload d-inline-block",
                          staticStyle: {
                            "background-size": "cover",
                            "background-position": "center",
                            position: "relative",
                            "border-radius": "2px",
                            outline: "none"
                          },
                          attrs: { id: file.id }
                        },
                        [
                          _c("div", { staticClass: "file-view-wrapper" }, [
                            _c(
                              "div",
                              {
                                staticClass: "img-delete",
                                on: {
                                  click: function($event) {
                                    _vm.deleteFile(file.id)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/gallery-close.svg")
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-content-start p-4 image-wrapper"
                              },
                              [
                                _c("div", { staticClass: "mr-2" }, [
                                  file.mime === "image/gif" ||
                                  file.mime === "image/png" ||
                                  file.mime === "image/jpg" ||
                                  file.mime === "image/jpeg"
                                    ? _c("span", [
                                        _c("i", { staticClass: "fa fa-image" })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  file.mime === "application/pdf" ||
                                  file.mime === "text/plain" ||
                                  file.mime === "application/msword" ||
                                  file.mime ===
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                                  file.mime === "application/vnd.ms-excel" ||
                                  file.mime ===
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    ? _c("span", [
                                        _c("i", { staticClass: "fa fa-file" })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  file.mime === "video/x-msvideo" ||
                                  file.mime === "video/mpeg" ||
                                  file.mime === "video/mp4" ||
                                  file.mime === "video/x-ms-wmv" ||
                                  file.mime === "video/avi" ||
                                  file.mime === "application/x-troff-msvideo" ||
                                  file.mime === "video/msvideo" ||
                                  file.mime === "video/x-mpeg"
                                    ? _c("span", [
                                        _c("i", { staticClass: "fa fa-video" })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  file.mime === "audio/mpeg" ||
                                  file.mime === "audio/x-ms-wma" ||
                                  file.mime === "audio/mpeg3" ||
                                  file.mime === "audio/x-mpeg-3" ||
                                  file.mime === "audio/mp3"
                                    ? _c("span", [
                                        _c("i", {
                                          staticClass: "fa fa-file-audio"
                                        })
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "img-link pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.viewImg(file.url)
                                      }
                                    }
                                  },
                                  [_c("p", [_vm._v(_vm._s(file.name))])]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-content-start p-4 image-wrapper"
                              },
                              [_c("p", [_vm._v(_vm._s(file.date))])]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                })
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5a2a528", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5a2a528","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimAttachments.vue
// module id = null
// module chunks = 